import { useCallback, useState } from "react";

export const useHandleReOnboardingRequestDialog = () => {
	const [canShowReOnboardingRequestDialog, setCanShowReOnboardingRequest] = useState(false);

	const handleOpenReOnboardingRequestDialog = useCallback(() => {
		setCanShowReOnboardingRequest(true);
	}, []);

	const handleChangeCanShowReOnboardingRequestDialog = useCallback(() => {
		setCanShowReOnboardingRequest((prev) => !prev);
	}, []);

	return {
		canShowReOnboardingRequestDialog,

		handleOpenReOnboardingRequestDialog,
		handleChangeCanShowReOnboardingRequestDialog,
	};
};
